import { ROUTES } from 'constants/routes';
import FileManagement from '@components/file-management';
import ExternalDeliveryFilesFilter from '@components/filters/external-delivery-files';

import { externalDeliveryFilesListColumns } from './list-data';
import { useEffect, useState } from 'react';
import { Classification, DepartmentCode } from 'types';
import { getExternalDeliveryFileList } from 'shared/helpers/external-delivery/get-external-delivery-file-list';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkPayloadObject } from 'shared/helpers/checkPayloadObject';

type ListDataType = {
  page: number;
  size: number;
  sortName: 'lfsKind' | 'deptCd' | 'originName' | '';
  sortType: 'asc' | 'dsc' | '' | null;
  schLfsKind: '' | 'allow' | 'deny';
  schDeptCd: DepartmentCode | '';
  schGroup: 'subject' | 'filename' | 'subject_filename' | '';
  schKeyword: string;
  adminConfigEnv: {
    cssJsVersion: string;
  } | null;
  shmList:
  | [
    {
      shmSeq: string;
      shmLfsKind: Classification;
      shmDeptCd: DepartmentCode;
      fileCount: number;
      shmSubject: string;
      shmfOriginName: string;
      shmfSize: number;
      regDt: string;
    },
  ]
  | [];
  totalCount: number;
};

const ExternalDeliveryFilesViewPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setLoading] = useState<boolean>(false)
  const initialData: ListDataType = {
    page: 1,
    size: 10,
    sortName: '',
    sortType: '',
    schLfsKind: '',
    schDeptCd: '',
    schGroup: '',
    schKeyword: '',
    adminConfigEnv: null,
    shmList: [],
    totalCount: 0,
  }
  const [listData, setListData] = useState<ListDataType>(initialData);

  useEffect(() => {
    const isRefresh = location?.state?.refresh

    const fetchData = async () => {
      setLoading(true)
      await getExternalDeliveryFileList(listData,
        [
          // @ts-ignore
          { key: 'page', value: 1 }, { key: 'schLfsKind', value: '' }, { key: 'schDeptCd', value: '', },
          // @ts-ignore
          { key: 'schGroup', value: 'subject_filename' }, { key: 'schKeyword', value: '' }
        ],
        setListData,
        ['page', 'schLfsKind', 'schDeptCd', 'schGroup', 'schKeyword'])
      setLoading(false)
    }

    if (isRefresh) {
      fetchData()
    }
  }, [location?.state])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await getExternalDeliveryFileList(listData, [], setListData, []);
      setLoading(false)
    }
    fetchData()
  }, []);

  return (
    <FileManagement
      isLoading={isLoading}
      title="외부 공유용 대용량 파일"
      linkStack={[
        {
          label: 'Home',
          path: ROUTES.EXTERNAL_DELIVERY_FILES.ROOT,
        },
        {
          label: '외부 공유용 대용량 파일',
          path: ROUTES.EXTERNAL_DELIVERY_FILES.ROOT,
        },
      ]}
      Filter={
        <ExternalDeliveryFilesFilter
          isLoading={isLoading}
          getFilteredList={async (payload) => {
            setLoading(true)
            await getExternalDeliveryFileList(listData, payload, setListData, [
              'page',
              'schLfsKind',
              'schDeptCd',
              'schGroup',
              'schKeyword',
            ])
            if (!checkPayloadObject(payload)) {
              navigate(
                ROUTES.EXTERNAL_DELIVERY_FILES.ROOT,
                { state: { page: payload[0].value, notEmpty: true } }
              )
            }
            setLoading(false)
          }}
          isCreateAction={true}
          createActionPath={ROUTES.EXTERNAL_DELIVERY_FILES.REGISTER_FILE.path}
        />
      }
      isCreateAction={true}
      createActionPath={ROUTES.EXTERNAL_DELIVERY_FILES.REGISTER_FILE.path}
      type="EXTERNAL_DELIVERY"
      listData={{
        columns: externalDeliveryFilesListColumns,
        rows: listData?.shmList?.map((item, index) => {
          return {
            id:
              listData.totalCount - (listData.page - 1) * listData.size - index,
            ...item,
          };
        }),
        totalCount: listData.totalCount,
        page: listData.page,
        pageSize: listData.size,
        serviceRequiredData: listData,
        setServiceRequiredData: setListData,
      }}
      getFilteredList={(payload) =>
        getExternalDeliveryFileList(listData, payload, setListData, [
          'sortName',
          'sortType',
        ])
      }
      handlePagination={async (payload) => {
        await getExternalDeliveryFileList(listData, payload, setListData, ['page'])
        if (!checkPayloadObject(payload)) {
          navigate(
            ROUTES.EXTERNAL_DELIVERY_FILES.ROOT,
            { state: { page: payload[0].value, notEmpty: true } }
          )
        }
      }}
    />
  );
};

export default ExternalDeliveryFilesViewPage;
